var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('img',{staticClass:"page-footer",class:{ mobile: _vm.$route.meta.mobile },attrs:{"src":_vm.footerLogo}})])}
var staticRenderFns = []

export { render, staticRenderFns }